<script>
import api from './../apiBridge'
import formatting from './../common/formatting.js'
import dateFormat from 'dateformat'
import router from './../router';
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {

  name: 'bin',

  components: {
    'swiper': swiper,
    'swiper-slide': swiperSlide
  },


  created: function () {
    // private data
  },

  methods: {
    getTimeBrackets() {
        console.log('Get time brackets');

        var self = this;
        api.jarvisBinManagement(api.storeNumber, dateFormat(new Date(),'yyyy-mm-dd'), function (response) {
            self.timeBrackets = response.data;
            self.updateCurrentBracket();

            self.$forceUpdate();
        });
    },

    updateCurrentBracket() {
        this.currentBracket = null;

        // reset time to device clock
        this.currentTime =  new Date();

        if (this.currentTime && this.timeBrackets && this.timeBrackets.length) {
            let fromTime, toTime;
            for (let t=0; t<this.timeBrackets.length; t++) {
                fromTime = formatting.dateFormat.dateFromStr(this.timeBrackets[t].from + ':00');
                toTime = formatting.dateFormat.dateFromStr(this.timeBrackets[t].to + ':00');

                if (this.currentTime >= fromTime && this.currentTime < toTime) {
                    this.currentBracket = this.timeBrackets[t];

                    let prevBracket = (t==0) 
                                    ? null
                                    : this.timeBrackets[t-1];

                    let nextBracket = (t==this.timeBrackets.length-1) 
                                    ? null
                                    : this.timeBrackets[t+1];

                    this.processBinData(this.currentBracket.supplies, prevBracket, nextBracket);

                    // set labels
                    this.currentBracket.fromTime = this.currentBracket.from.split('T')[1].replace('.000Z', '');
                    this.currentBracket.toTime = this.currentBracket.to.split('T')[1].replace('.000Z', '');

                    break;
                }
            }
        }
    },

    processBinData(binList, prevBracket, nextBracket) {
        this.binList = binList || this.currentBracket.supplies;


        for (let b=0; b<this.binList.length; b++) {

            this.binList[b].prevQty = '';
            this.binList[b].nextQty = '';

            if (prevBracket && prevBracket.supplies) {
                for (let p=0; p<prevBracket.supplies.length; p++) {
                    if (this.binList[b].id == prevBracket.supplies[p].id) {
                        this.binList[b].prevQty = prevBracket.supplies[p].qty;
                    }
                }
            } 

            if (nextBracket && nextBracket.supplies) {
                for (let n=0; n<nextBracket.supplies.length; n++) {
                    if (this.binList[b].id == nextBracket.supplies[n].id) {
                        this.binList[b].nextQty = nextBracket.supplies[n].qty;
                    }
                }
            } 
        }


    },    

    updateElapsedTime() {
      if (this.currentTime) {
        // add 1 second to current time counter
        this.currentTime.setSeconds(this.currentTime.getSeconds() + 1);

        // refresh page at 4:30am 
        if (this.currentTime.getHours() == 4
            && this.currentTime.getMinutes() == 30
            && this.currentTime.getSeconds() == 0) {
          this.init();
        }

        if (this.currentBracket) {
            const toTime = formatting.dateFormat.dateFromStr(this.currentBracket.to);
            this.elapsedTime = formatting.dateFormat.calcElapsedTime(this.currentTime, toTime).time;

            if (this.elapsedTime == '0:00' || this.elapsedTime.indexOf('-1D')>=0) {
              this.remainingLabel = this.LOADING + '...';
              this.elapsedTime = '';

              this.updateCurrentBracket();
            } else {
              this.remainingLabel = this.REMAINING + ':';
            }
        } else {
            this.updateCurrentBracket();
        }
        
      }
    },  

    gotoMain() {
      router.push('/main');
    },

    reload() {
      location.reload(true);
    },

    gotoInfo() {
      router.push('/info');
    },    

    init() {
        if (!api.storeSelected) {
            router.push('/login');
        }

        this.remainingLabel = this.$t('loading') + '...';
        this.elapsedTime = '';

        this.currentTime =  new Date();
        this.getTimeBrackets();

        if (this.uiInterval) clearInterval(this.uiInterval);
        this.uiInterval = setInterval(() => {
            this.updateElapsedTime();
        }, 1000);

        setTimeout (() => {
            // logout button initially disabled to prevent accidental click
            // re-enable after some time
            this.logoutTimeout = false;
        }, 2000);
    }

  },

  mounted: function(){
    console.log('Bin Management page');
    document.body.style.backgroundColor = "#000";

    this.LOADING = this.$t('loading');
    this.REMAINING = this.$t('remaining');


    this.init();
  },

  data() {
    return {
        timeBrackets: [],
        currentBracket: null,
        binList: [],
        elapsedTime: '',
        logoutTimeout: true,
        error: '',
        remainingLabel: this.$t('loading') + '...',
        swiperOption: {
          slidesPerView: 4,
          slidesPerColumn: 4,
          //slidesPerColumnFill: "row" ,
          //slidesPerGroup: 10,
          autoplay: {
              delay: 5000,
              disableOnInteraction: false
            },
          spaceBetween: 15,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
            type: 'progressbar'
          },
          breakpoints: {
            // less than
            580: {
              slidesPerView: 1,
              slidesPerColumn: 3,
              spaceBetween: 15
            },
            // less than
            780: {
              slidesPerView: 2,
              slidesPerColumn: 3,
              spaceBetween: 15
            },
            // less than
             1200: {
              slidesPerView: 3,
              slidesPerColumn: 3,
              spaceBetween: 15
            }
          }
         
        }
    }
  }

}
</script>

<template>
<div style=" ">
  <div class="row">
    
    <div v-if="currentBracket" class="col-sm-6" style="font-size: 24px; color: white;">
      {{currentBracket.fromTime || '00:00'}} - {{currentBracket.toTime || '00:00'}}
    </div>
    <div class="col-sm-6" style="font-size: 24px; color: white; text-align:right">
      {{remainingLabel}} <span style="color: gold;">{{elapsedTime}}</span>
    </div>
  </div>
  
  <div v-if="binList && binList.length" class="row" style="height:90%;position: relative;">
    <div class="col-sm-12">
      <swiper :options="swiperOption" class="swiper-box">
        <swiper-slide v-for="bin in binList" class="swiper-item" > 
          <div class="bin-tile">
            <table style="width:100%;text-align:center">
                <tr>
                    <td colspan="3">
                      <h2 style="padding:0px;margin:0px">{{bin.name}}</h2>  
                    </td> 
                  </tr> 
                  <tr>
                    <td style="width:20%">
                        <h1 v-if="bin.prevQty<bin.qty" style="color: maroon;">{{bin.prevQty}}</h1>
                        <h1 v-else style="color: green;">{{bin.prevQty}}</h1>
                    </td>
                    <td>
                      <h1 style="font-size:70px;font-weight:bold;">{{bin.qty}}</h1>
                    </td>
                    <td style="width:20%">
                      <h1 v-if="bin.nextQty<bin.qty" style="color: maroon;">{{bin.nextQty}}</h1>
                      <h1 v-else style="color: green;">{{bin.nextQty}}</h1>
                    </td>
                    
                  </tr> 
            </table>  
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
  </div>
  
  <div class="row" style="position:fixed;bottom:0px;width:100%;">
    <table style="width:100%">
        <tr>
            <td >
              </td> 
              <td style="width:40px">
                 <button 
                    @click="init()"
                    class="btn btn-block btn-lg btn-danger "
                    style="height: 42px; width: 42px; padding: 9px; font-weight: bold; border-radius: 50%;"
                    ><i class="fas fa-redo pull-left"
                    style="margin: 2px -20px 0px 0px; "
                    ></i></button>
              </td>
              <td>
                <button 
                @click="gotoInfo()"
                class="btn btn-lg pull-right btn-default"
                style="height: 40px; width: 40px; padding: 9px; font-weight: bold; border-radius: 50%; background-color: #000; border: none; color: #fff;"
                ><i class="fas fa-info-circle pull-left"
                  style="margin: 2px 5px 0px 0px;"></i>
                </button>
              </td>
         </tr> 
    </table>  

    <div class="col col-sm-2 pull-right">

    </div>        
  </div>
  
</div>


</template>
<style scoped>

.swiper-item {
    margin-top:0px !important;
     margin-bottom:0px !important;
  }
 
</style>


// WEBPACK FOOTER //
// BinManager.vue?7a61db65